import * as React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { LEFT_RIGHT, ConfigurationModel, BuiltInPartsPositionForDrillHole } from 'franke-trough-dependencies';

import { GlobalPrivateState } from 'src/api';

import './ElementPosition.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ElementPositions.messages';
import { UncontrolledTooltip } from 'reactstrap';

export interface ElementPositionsProps {
  defaults: BuiltInPartsPositionForDrillHole<LEFT_RIGHT[]>;
  id: string;
  positionChange?(positions: LEFT_RIGHT[]): void;
  positions: LEFT_RIGHT[];
  selectedTrough: ConfigurationModel['selectedTrough'];
  disabled: boolean;
}

export class ElementPositionsPartial extends React.Component<ElementPositionsProps> {
  constructor(props: ElementPositionsProps) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  public render() {
    const {
      positions,
      id,
      selectedTrough,
      disabled,
      defaults
    } = this.props;
    
    return (
      <div className="partial-element-positions">
        <div className="row mb-4">
          <div className="col-11 offset-1">
            <div className="row">
              <div className="col-12">
                {positions.map((pos, index) => {
                  const key = `${id}_position_${index}`;
                  const lineNr = index + 1;
                  const position = positions && positions[index] || pos;
                  // default.builtInParts.soapDispenserHolePositions.isDrillHoleAllowed is sometimes empty, weird!
                  const isAllowed = defaults.isDrillHoleAllowed.length > 0 && defaults.isDrillHoleAllowed[index] || {left: false, right: false};
                  const checked = {
                    left: position === 'left' && isAllowed.left,
                    right: position === 'right' && isAllowed.right
                  };
                  
                  return (
                    <div key={key} className="row lines border-bottom pt-2 pb-1">
                      <div className="col-6 col-md-4">
                        <small>{lineNr}. {selectedTrough && selectedTrough.trough.name}</small>
                      </div>
                      <div className="col-3 col-md-4">
                        {!isAllowed.left && (
                          <UncontrolledTooltip target={`label_left_${key}`}>
                            <FormattedMessage {...MESSAGES.warningElementPosition} />
                          </UncontrolledTooltip>
                        )}
                        <label className={classNames({disabled: (!isAllowed.left || disabled)})}>
                          <FormattedMessage {...MESSAGES.elementsPositionsLeft} />
                          <input
                            checked={checked.left ? true : false}
                            disabled={!isAllowed.left || disabled}
                            name={`${id}_left_${index}`}
                            onChange={(event) => this.handleChange(event, index)}
                            type="radio"
                            value="left"
                          />
                          <span id={`label_left_${key}`} className="checkmark" />
                        </label>
                      </div>
                      <div className="col-3 col-md-4">
                        {!isAllowed.right && (
                          <UncontrolledTooltip target={`label_right_${key}`}>
                            <FormattedMessage {...MESSAGES.warningElementPosition} />
                          </UncontrolledTooltip>
                        )}
                        <label className={classNames({disabled: (!isAllowed.right || disabled)})}>
                          <FormattedMessage {...MESSAGES.elementsPositionsRight} />
                          <input
                            checked={checked.right ? true : false}
                            disabled={!isAllowed.right || disabled}
                            name={`${id}_right_${index}`}
                            onChange={(event) => this.handleChange(event, index)}
                            type="radio"
                            value="right"
                          />
                          <span id={`label_right_${key}`} className="checkmark" />
                        </label>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  private handleChange(event: React.SyntheticEvent<HTMLInputElement>, index: number) {
    const positions = this.props.positions;
    const target = event.target as HTMLInputElement;
    const value = target.value as LEFT_RIGHT;
    
    if (positions && positions[index]) {
      positions[index] = value;
    }
    if (this.props.positionChange) {
      this.props.positionChange(positions);
    }
  }
}

export const ElementPositions = connect((state: GlobalPrivateState) => ({
  // configuration: state.configuration,
}))(ElementPositionsPartial);

export default ElementPositions;